function isArraysEqual(a, b, toUniqueId) {
  var an, aLength = a.length, a_sum = 0, a_sum_of_square = 0,
      bn, bLength = b.length, b_sum = 0, b_sum_of_square = 0;

  if (aLength !== bLength) {
    return false;
  }

  while(aLength) {
    --aLength;
    if (toUniqueId) {
      an = toUniqueId(a[aLength]);
      bn = toUniqueId(b[aLength]);
    } else {
      an = a[aLength];
      bn = b[aLength];
    }
    a_sum += an;
    a_sum_of_square += an * an;
    b_sum += bn;
    b_sum_of_square += bn * bn;
  }

  return a_sum === b_sum && a_sum_of_square === b_sum_of_square;
};

module.exports = isArraysEqual;



//////////////////
// WEBPACK FOOTER
// ./~/is-arrays-equal/is_arrays_equal.js
// module id = 514
// module chunks = 1